import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW4401Model } from './kymw4401.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW4401InputModel } from './vo/kymw4401-input.model';
import { KYMW4401OutputModel } from './vo/kymw4401-output.model';
import { PlessViewUtils } from '../../../shared/utils/pless-view-utils.service';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { CopyPageInfoService } from './api-services/copy-page-info.service';
import { CoopCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/coop-code-combo-box/coop-code-combo-box.component';
import { GetMediumListService } from '../../../commons/kymw02/api-services/get-medium-list.service';

/**
 * コピー設定を管理するクラス
 *
 * @export KYMW4401Component
 * @class KYMW4401Component
 */
@Component({
  selector: 'app-kymw4401',
  templateUrl: 'kymw4401.component.html',
  styleUrls: ['kymw4401.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW4401Component
  extends PlessViewHelperSub
  implements OnInit, AfterViewInit
{
  @ViewChild('btn_Set', { static: false }) btn_Set: ElementRef;
  @ViewChild('cmb_CoopCode', { static: false })
  cmb_CoopCode: CoopCodeComboBoxComponent;

  public model: KYMW4401Model = new KYMW4401Model();
  private _output: KYMW4401OutputModel = null;

  private validations: {
    invalid: (m: KYMW4401Model) => boolean;
    code: string;
    messages: string[];
  }[] = [
    {
      invalid: m => PlessViewUtils.isEmpty(m.orderCodeOrigin),
      code: 'W0001',
      messages: ['コピー元受注コード'],
    },
    {
      invalid: m => PlessViewUtils.isEmpty(m.catalogIdOrigin),
      code: 'W0001',
      messages: ['コピー元企画回'],
    },
    {
      invalid: m => PlessViewUtils.isEmpty(m.coopCode),
      code: 'E0103',
      messages: ['コピー元会員生協'],
    },
    {
      invalid: m => PlessViewUtils.isEmpty(m.orderCodeFromCopy),
      code: 'W0001',
      messages: ['コピー先受注コード'],
    },
    {
      invalid: m => PlessViewUtils.isEmpty(m.orderCodeToCopy),
      code: 'W0001',
      messages: ['コピー先受注コード'],
    },
    {
      invalid: m => m.orderCodeFromCopy > m.orderCodeToCopy,
      code: 'W0024',
      messages: ['コピー先受注コード'],
    },
    {
      invalid: m => PlessViewUtils.isEmpty(m.catalogIdFromCopy),
      code: 'W0001',
      messages: ['コピー先企画回'],
    },
    {
      invalid: m => PlessViewUtils.isEmpty(m.catalogIdToCopy),
      code: 'W0001',
      messages: ['コピー先企画回'],
    },
    {
      invalid: m => m.catalogIdFromCopy > m.catalogIdToCopy,
      code: 'W0024',
      messages: ['コピー先企画回'],
    },
  ];

  /**
   * Creates an instance of KYMW4401Component.
   *
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {GetMediumListService} getMediumListService
   * @param {CopyPageInfoService} copyPageInfoService
   * @memberof KYMW4401Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getMediumListService: GetMediumListService,
    private copyPageInfoService: CopyPageInfoService,
    private kymw00Model: KYMW00Model
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW4401Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4401';
    this.getMediumListService.execute(null, this.model, 'mediumList');
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW4401Component
   */
  public ngAfterViewInit(): void {}

  /**
   * ボタン押下 設定
   *
   * @memberof KYMW4401Component
   */
  public set() {
    // バリデーション
    const invalidItem = this.validations.find(_ => _.invalid(this.model));
    if (invalidItem) {
      this.dialogService.openAlertGetMessage(
        invalidItem.code,
        invalidItem.messages
      );
      return;
    }
    // ダイアログ表示・APIリクエスト
    this.dialogService.openAlertGetMessage('Q0170', [], _e => {
      if (_e === PlessAlert.Yes) {
        this.copyPageInfoService.execute(this.model, () => {
          this._output = {
            mediumType: this.model.mediumType,
            orderCode: this.model.orderCodeFromCopy,
            catalogId: this.model.catalogIdFromCopy,
            coopCode: this.model.coopCode,
          };
          this.closeFunction();
        });
      }
    });
  }

  public dspCoopCode() {
    const name = this.cmb_CoopCode?.selectedCoopName ?? '';
    if (!name) return '';
    return this.model.coopCode + ':' + name;
  }

  /**
   * 呼び出し側から利用
   *
   */
  public getParams(): KYMW4401OutputModel {
    return this._output;
  }

  /**
   * 呼び出し側から利用
   *
   */
  public setParams(data: KYMW4401InputModel) {
    this.model.mediumType = data.mediumType;
    this.model.coopCode = data.coopCode;
  }
}
